module.exports = __webpack_public_path__ + "static/media/ic_logout.5af4713d.svg";